<div class="page-container">
  <app-card>
    <div class="error-state">
      <app-icon name="alert-triangle" [size]="64" color="var(--fg-danger)" />
      <h1>{{ 'billingSuspended.title' | translate }}</h1>
      <p class="description">{{ 'billingSuspended.description' | translate }}</p>

      <div class="warning-box">
        <app-icon name="alert-circle" color="var(--fg-warning)" />
        <div>
          <h3>{{ 'billingSuspended.warning.title' | translate }}</h3>
          <p>{{ 'billingSuspended.warning.description' | translate }}</p>
        </div>
      </div>

      <div class="actions">
        <app-button variant="filled" (click)="goToBilling()" data-testid="billing-suspended-go-to-billing">
          {{ 'billingSuspended.goToBilling' | translate }}
        </app-button>
        <app-button variant="text" (click)="logout()" data-testid="billing-suspended-logout">
          {{ 'billingSuspended.logout' | translate }}
        </app-button>
      </div>
    </div>
  </app-card>
</div>
